<template>
  <div id="JtFormCard">
    <div v-if="isLoading" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>
    <jt-dynamic-form
      ref="jtDynamicForm"
      v-else-if="shouldShowForm"
      :inputs="form.inputs"
      :interface="form.nmInterface"
      :relacionamentos="form.relacionamentos"
      :model="form.dadosForm"
      :buttons="form.buttons"
      form-class="form"
      @form-button-click="onFormButtonClick"
    />
    <div v-else class="div-not-render">
      <h3>{{ $gettext("NO_FORM_RENDER") }}</h3>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'src/jtech/jtech-repository'

@Component({
  name: 'JtFormCard',
  components: {
    JtDynamicForm
  },
  props: {
    cardKey: {
      type: [Number, String],
      required: true
    },
    nmInterface: {
      type: String,
      required: true
    },
    shouldShowClearFormButton: {
      type: Boolean,
      required: false,
      default: true
    },
    shouldPreventDefaultActionsButtons: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
export default class JtFormCard extends Vue {
  shouldShowForm = false
  form = {}
  isLoading = false
  btActions = {
    btCleanJtFormCard: () => this.$refs.jtDynamicForm.resetForm(),
    btExecutar: async (nmInterface, params) => await repository.resolveLogic(nmInterface, params),
    btGravar: async (nmInterface, params) => {
      await repository.create(nmInterface, params)
      this.$refs.jtDynamicForm.resetForm()
    }
  }

  async mounted () {
    await this.reload()
  }

  customizeFormButtons (buttons) {
    buttons.forEach(button => {
      if (button.type === 'BUTTON') button.type = 'SUBMIT'
    })
    if (this.shouldShowClearFormButton) {
      return [
        {
          label: this.$gettext('CLEAN'),
          name: 'btCleanJtFormCard',
          type: 'CANCEL'
        },
        ...buttons
      ]
    } else {
      return buttons
    }
  }

  onFormButtonClick ({ button, fields }) {
    if (button.name in this.btActions && !this.shouldPreventDefaultActionsButtons) {
      this.btActions[button.name](button.action, fields)
    } else {
      this.$emit('form-button-click', { cardKey: this.cardKey, button, form: fields })
    }
  }

  async reload () {
    this.isLoading = true
    let form = {}
    if (this.nmInterface) {
      try {
        const res = await repository.resolve(this.nmInterface, {})
        form = res[0]
      } catch {
        console.error(`InfoCard: ${this.cardKey}. There was an error when trying to load the form.`)
      }
    } else {
      console.error(`InfoCard: ${this.cardKey}. Missing "nmInterface".`)
    }
    this.shouldShowForm = form.buttons && form.buttons.length > 0
    if (this.shouldShowForm) {
      form.buttons = this.customizeFormButtons(form.buttons)
      this.form = form
    } else {
      this.form = {}
    }
    this.isLoading = false
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

#JtFormCard {
  height: 100%;
  overflow-x: hidden;

  .form {
    /deep/ #scroll-area {
      height: calc(100% - 50px);
    }
  }

  .div-not-render {
    height: 100%;
    display: flex;
    align-items: center;

    h3 {
      text-align: center;
    }
  }
}
</style>
